import React from 'react';
import CustomButton from '../../../common/components/CustomButton';
import PopupContainer from '../../../common/components/PopupContainer';

export default function MusicAlbumEditForm3IncompletePopup({
  onClose,
} : {
  onClose: () => void,
}) {
  return (
    <PopupContainer title="曲情報の入力" onClose={() => { onClose(); }}>
      <form>
        <div className="list__body">
          <p>曲情報に未入力があります。</p>
          <p>すべての曲の情報を入力してください。</p>
          <p className="top_line" />
          <ul>
            <li className="bt">
              <CustomButton type="cancel" onClick={() => { onClose(); }}>閉じる</CustomButton>
            </li>
          </ul>
        </div>
      </form>
    </PopupContainer>
  );
}
